import { environment } from "src/environments/environment";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { catchError, map, throwError } from "rxjs";
import { BlogService } from "src/app/services/blog.service";
import { formatDate } from "src/app/utils/date-utils";
import { titleSplit } from "src/app/utils/title-split";
import { Title } from "@angular/platform-browser";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-blog-deatils",
  templateUrl: "./blog-deatils.component.html",
  styleUrls: ["./blog-deatils.component.scss"],
})
export class BlogDeatilsComponent implements OnInit {
  item: any;
  slug: string | null = null;
  title1: string | undefined;
  title2: string | undefined;

  constructor(
    private ativatedRoute: ActivatedRoute,
    private blog: BlogService,
    private titleService: Title,
    private seoService: SeoServiceService
  ) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.slug = this.ativatedRoute.snapshot.paramMap.get("slug");
    this.getBlogs();
  }

  getBlogs() {
    this.blog
      .getgenre()
      .pipe(
        map((res: any) => {
          this.item = res.data.find(
            ({ attributes }: any) => attributes.slug === this.slug
          );
          this.titleService.setTitle(this.item?.attributes.title);
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  gettitle(title: string | null, part = false): string {
    return titleSplit(title, part);
  }

  getImage(imageURL: String) {
    return environment.baseBlogUrl + imageURL;
  }

  Date(date: string): string {
    return formatDate(date);
  }
}
